import { Link } from "react-router-dom";
import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";
import { newsList } from "@/mocks/news";

export default function News() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: 'ニュース' }]}>

      {/* Content Card */}
      <div className="px-4 md:px-6 lg:px-10 pb-12 md:pb-16">
        <div className="bg-white rounded-[20px] overflow-hidden">
          <div className="p-5 lg:p-7">
            <div ref={ref} className={getRevealClass(isVisible)}>
              <div className="flex items-end justify-between mb-8">
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold text-black tracking-tight mb-1">News</h2>
                  <p className="text-xs text-gray-400 mb-3">ニュース</p>
                  <div className="w-8 h-px bg-black" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {newsList.map((item) => (
                <Link
                  key={item.id}
                  to={`/news/${item.id}`}
                  className="group cursor-pointer block"
                >
                  <div className="w-4/5 mx-auto aspect-square overflow-hidden rounded-lg mb-3">
                    <img
                      src={item.image}
                      alt={item.title}
                      className={`w-full h-full object-cover ${
                        item.id === "006" || item.id === "008"
                          ? "object-bottom"
                          : item.id === "010" || item.id === "011" || item.id === "012" || item.id === "013" || item.id === "014" || item.id === "016"
                            ? "object-center"
                            : "object-top"
                      } group-hover:scale-105 transition-transform duration-500`}
                    />
                  </div>
                  <div className="w-4/5 mx-auto">
                    <div className="flex items-center gap-3 mb-1.5">
                      <span className="text-[10px] text-gray-400 tracking-wider whitespace-nowrap">{item.date}</span>
                      <span className="text-[10px] border border-gray-300 text-gray-500 px-2 py-0.5 whitespace-nowrap">{item.category}</span>
                    </div>
                    <p className="text-sm font-medium text-black line-clamp-2 leading-relaxed">{item.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}